import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var myReserverSlice = createSlice({
    name: "myReserver",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _myReserverSlice_actions = myReserverSlice.actions;
export var fetchData = _myReserverSlice_actions.fetchData, fetchDataSuccess = _myReserverSlice_actions.fetchDataSuccess, fetchDataFailure = _myReserverSlice_actions.fetchDataFailure, resetState = _myReserverSlice_actions.resetState;
export default myReserverSlice.reducer;
